'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationView = void 0;
var NavigationView;
(function (NavigationView) {
    NavigationView["MOBILE"] = "mobile";
    NavigationView["DESKTOP"] = "desktop";
})(NavigationView = exports.NavigationView || (exports.NavigationView = {}));
